import { TUserProfile } from './types'
import UserProfileContextProvider from './Providers/UserProfileContextProvider'
import { UserProfile } from './UserProfile'

export const UserProfileContainer = ({ setActiveTab }: TUserProfile) => {
  return (
    <UserProfileContextProvider>
      <UserProfile setActiveTab={setActiveTab} />
    </UserProfileContextProvider>
  )
}
